import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "bulb" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15,17.25V19.5A1.5,1.5,0,0,1,13.5,21h-3A1.5,1.5,0,0,1,9,19.5V17.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: .75,
			x2: 12,
			y2: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.5,
			y1: 11.25,
			x2: 3,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 3.75,
			x2: 4.85,
			y2: 4.807
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 22.5,
			y1: 11.25,
			x2: 21,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: 3.75,
			x2: 19.15,
			y2: 4.807
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.915,17.25h6.17a6.6,6.6,0,0,0,3.665-6A6.873,6.873,0,0,0,12,4.5a6.873,6.873,0,0,0-6.75,6.754A6.6,6.6,0,0,0,8.915,17.25Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 21,
			x2: 12,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 13.5,
			x2: 12,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "9.75 11.25 12 13.5 14.25 11.25"
		})
	]
});
export default SvgBulb;
